// @flow

import React from 'react';
import { observer } from 'mobx-react';
import pluralize from 'pluralize';
import Select from 'react-select';
import { css } from 'glamor';
import { Col, Clearfix } from 'react-bootstrap';

import PlatformList from '~/components/content/platform/PlatformList';
import Loader from '~/components/global/Loader';
import SearchInput from '~/components/global/SearchInput';
import SearchPanel from '~/components/global/SearchPanel';
import type { Platform as PlatformType, Company as CompanyType } from '~/types';

const searchPanelRule = css({
    marginBottom: '15px',
    margin: '8px',
});

const resultsRule = css({
    fontWeight: 400,
});

const inputSpacer = css({
    '@media(max-width: 768px)': {
        marginBottom: '15px',
    },
});

@observer
export default class PlatformsPage extends React.Component {
    props: {
        maker: CompanyType,
        makers: Array<CompanyType>,
        platforms: Array<PlatformType>,
        onInputChange: () => void,
        onMakerChange: () => void,
    };

    render() {
        const {
            platforms = [],
            maker,
            makers = [],
            onInputChange,
            onMakerChange,
        } = this.props;
        const platformCount = platforms.length;
        const Results = platforms.length ?
            (<Col md={ 12 }>
                  <span { ...resultsRule }>
                      {`${platformCount} ${pluralize('result', platformCount)} found`}
                  </span>
              </Col>) :
            (<Col md={ 12 }>
                  <span { ...resultsRule }>
                      {'No result found for these search criteria.'}
                  </span>
              </Col>);

        return (
            <div>
                <h4>
                    {'Platforms'}
                </h4>
                <div { ...searchPanelRule }>
                    <SearchPanel>
                        <Col md={ 8 } { ...inputSpacer }>
                            <SearchInput
                                callback={ onInputChange }
                                icon
                                placeholder="Super Famicom, PC Engine, Famicom..."
                            />
                        </Col>
                        <Col md={ 3 } { ...inputSpacer }>

                            <Select
                                labelKey="name"
                                name="maker"
                                onChange={ onMakerChange }
                                options={ makers }
                                placeholder="All makers"
                                value={ maker }
                                valueKey="id"
                            />
                        </Col>
                        <Col md={ 1 }>
                            <Loader />
                        </Col>
                        <Clearfix />
                    </SearchPanel>
                </div>

                {Results}

                <PlatformList platforms={ platforms } />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/content/containers/PlatformsPage.js